<template>
  <div class="uploadImg-item">
    <a-upload
      accept="image/*"
      list-type="picture-card"
      class="avatar-uploader"
      :show-upload-list="false"
      :maxCount="1"
      :customRequest="beforeUpload"
      :disabled="disabledImg"
    >
      <div class="img-wrapper" v-if="imageUrl">
        <img class="img" :src="imageUrl" alt="avatar" />
        <div class="hover-img">
          <DeleteOutlined style="color: #FFF;" @click.stop="delImg" />
        </div>
      </div>

      <div v-else>
        <loading-outlined v-if="loading"></loading-outlined>
        <plus-outlined v-else></plus-outlined>
        <div class="ant-upload-text">上传图片</div>
      </div>
    </a-upload>
    <div class="tip">
      {{ tip }}
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import {
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
export default {
  components: {
    PlusOutlined,
    LoadingOutlined,
    DeleteOutlined
  },
  props: ['imageType', 'defaultUrl', 'disabled'],
  setup(props, { emit }) {
    const imageUrl = ref(props.defaultUrl)
    const tip = ref(props.imageType.tip)
    const loading = ref(false)
    const disabledImg = ref(props.disabled)

    const beforeUpload = file => {
      return new Promise((resolve, reject) => {
        const isSize = file.file.size / 1024 > props.imageType.size
        if (isSize) {
          message.warning(`上传的图片不能大于${props.imageType.size}kb`)
          return reject(false)
        }
        let w = 0,
          h = 0
        const reader = new FileReader()
        reader.readAsDataURL(file.file)
        reader.onload = () => {
          const image = new Image()
          image.src = reader.result
          image.onload = () => {
            w = image.width
            h = image.height

            if (w === props.imageType.width && h === props.imageType.height) {
              uploadImg(file.file)
              // 图片尺寸上限为550
              return resolve(true)
            }
            message.warning('图片尺寸不正确！')
            return reject(false)
          }
        }
      })
    }
    const uploadImg = async file => {
      loading.value = true
      const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
      const { success, data } = await formRequest(api, {
        file: file
      })
      if (success) {
        loading.value = false
        emit('setImgUrl', data.url)
      }
    }
    const delImg = () => {
      if (!disabledImg.value) {
        emit('delActivityImg')
      }
    }
    watch(
      () => props.defaultUrl,
      () => {
        imageUrl.value = props.defaultUrl
      },
      { deep: true }
    )
    return {
      disabledImg,
      imageUrl,
      loading,
      tip,
      beforeUpload,
      delImg
    }
  }
}
</script>

<style lang="scss" scoped>
.uploadImg-item {
  display: flex;
  flex-direction: column;
  .tip {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    width: 104px;

    text-align: center;
  }
  .img-wrapper {
    position: relative;
    .img {
      width: 100%;
    }
    .hover-img {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
    }
    &:hover .hover-img {
      display: flex;
      background-color: rgba(0, 0, 0, 0.45);
      align-items: center;
      justify-content: center;
    }
  }
}
.ant-upload-picture-card-wrapper {
  width: 104px;
  margin: 0;
  margin: 10px;
}
</style>
